import { render, staticRenderFns } from "./CourseCenter.vue?vue&type=template&id=3e2cb3cc&scoped=true"
import script from "./CourseCenter.vue?vue&type=script&lang=js"
export * from "./CourseCenter.vue?vue&type=script&lang=js"
import style0 from "./CourseCenter.vue?vue&type=style&index=0&id=3e2cb3cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2cb3cc",
  null
  
)

export default component.exports